import React from "react";
import { PathwayBadge } from "./PathwayBadge";
import { FaCrown } from "react-icons/fa";

const VipBadge = ({ hasActiveVipSupport, isSuperUser, size = "md", dataCy }) => {
    if (!isSuperUser || !hasActiveVipSupport) return null;
    return (
        <PathwayBadge variant="vip" size={size} dataCy={dataCy}>
            <FaCrown aria-hidden="true" /> VIP
        </PathwayBadge>
    );
};

export default VipBadge;
